import React, { useEffect, useState ,useMemo} from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import debounce from "lodash.debounce";
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  CardHeader,
  Badge,
  FormGroup,
  InputGroup,
  Input,
  
} from "reactstrap";
import moment from "moment";
import { FaEdit, FaTrash, FaImage,  FaPencilAlt } from "react-icons/fa";

import {
  getCategoryList,
  resetComponentStore,
  deleteCategory,
} from "actions/admin/blogsCategory";
import * as Constants from "constants/index";

const Stack = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction || "row"};
  align-items: ${(props) => props.alignItems || "initial"};
  -webkit-box-align: center;
  & > div:not(:first-child) {
    margin: 0px;
    margin-left: ${(props) =>
      props.direction !== "column" ? (props.gap || 1) * 8 + "px" : "0px"};
  }
`;

const CategoryWrapper = ({ _id, name, avatar }) => (
  // <Link to={`/dashboard/blog/category/${_id}/edit`} title={name}>
    <Stack alignItems="center">
      <Stack direction="column">
        <div style={{ fontSize: 16 }} className="text">
          {name}
        </div>
      </Stack>
    </Stack>
  // </Link>
);

const CategoryList = ({
  getCategoryList,
  loadingListData,
  deleteCategory,
  categoryList: { data, count, page },
  sortingParams,
  resetComponentStore,
}) => {
  // console.log(data, "datataatatata")
  const [categoryParams, setCategoryParams] = useState({
    limit: sortingParams.limit,
    page: sortingParams.page,
    orderBy: sortingParams.orderBy,
    ascending: sortingParams.ascending,
    query: sortingParams.query,
    filters: sortingParams.filters,
    count: count,
  });
  console.log(sortingParams, count, page);
  const [onlyOnce, setOnce] = useState(true);

  const handleDeleteCategory = (_id) => {
    if (window.confirm("Are you sure you want to delete")) deleteCategory(_id);
  };
  const [search, setSearch] = React.useState("")
  const columns = [
    {
      name: "Name",
      sortable: true,
      width: "400px",
      field: "name",
      selector: (row) => row.name,
      format: (row) => {
        const { _id, avatar, name } = row;
        // console.log(name);
        return <CategoryWrapper name={name} _id={_id} />;
      },
    },
    
    {
      name: "Status",
      sortable: true,
      field: "status",
      width: "300px",
      selector: (row) => row.status,
      format: (row) => {
        return (
          <Badge color={row.status === 1 ? "success" : "danger"}>
            {row.status === 1 ? "Active" : "Inactive"}{" "}
          </Badge>
        );
      },
    },
    {
      name: "Actions",
      width: "300px",
      selector: (row) => row.actions,
      format: (row) => {
        const _id = row._id;
        return (
          <Stack>
            <div>
              <Link
                to={`/dashboard/blog/category/${_id}/edit`}
                title="edit"
                // className="btn btn-outline-primary"

              >
                 <Button
              type="button"
              style={{ marginLeft: 4, color: "white" }}
              size="sm"
              color="success"
            >
              <FaPencilAlt />
            </Button>
              </Link>
            </div>
            {/* <div>
              <Link
                to={`/dashboard/blog/category/image/${_id}`}
                title="Image"
                className="btn btn-outline-success"
              >
                <FaImage />
              </Link>
            </div> */}
            <div onClick={() => handleDeleteCategory(_id)}>
              <Button
              type="button"
              style={{ marginLeft: 4, color: "white" }}
              size="sm"
              color="danger"
            >
              <FaTrash />
            </Button>
            </div>
          </Stack>
        );
      },
    },
  ];


//  useEffect(()=>{
//       console.log(getCategoryList)
//  })

  useEffect(() => {
    let subscribe = true;
    const asyncParams = async () => {
      try {
        if (subscribe) {
          if (onlyOnce) {
            resetComponentStore();
            setOnce(false);
          }
          getCategoryList(categoryParams);
        }
      } catch (err) {
        // throw err;
      }
    };
    asyncParams();
    return () => {
      subscribe = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryParams]);

  const handlePerRowsChange = async (newPerPage, page) => {
    setCategoryParams((prevParams) => ({
      ...prevParams,
      limit: newPerPage,
      page,
    }));
  };

  const handlePageChange = async (page) => {
    setCategoryParams((prevParams) => ({ ...prevParams, page }));
  };

  const handleSort = (column, sortDirection) => {
    const orderBy = column.field;
    setCategoryParams((prevParams) => ({
      ...prevParams,
      // orderBy,
      // ascending: sortDirection,
    }));
  };
  const searchHandler = useMemo(() => {
    return debounce((event) => {
      console.log(event.target.value,"search")
      setSearch(event.target.value)

      const filters=event.target.value;
      setCategoryParams((prevParams) => ({
        ...prevParams,
        // orderBy,
        // ascending: sortDirection,
        filters
      })); 

    }, 800)
  }, [])

  useEffect(() => {
    let subscribe = true;
    const asyncParams = async () => {
      try {
        if (subscribe) {
          console.log("page reload");
          setCategoryParams((params) => ({
            ...params,
            ...sortingParams,
            page: parseInt(page),
          }));
        }
      } catch (err) {
        // throw err;
      }
    };

    asyncParams();
    return () => {
      subscribe = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="animated fadeIn" style={{ marginTop: "5%" }}>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <Stack
                alignItems="center"
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  <h2>Category List</h2>
                </div>
                <div className="add-button-div">
                  <Link to="/dashboard/blog/category/create" title="create">
                    <Button color="primary" size="sm">
                      <i className="fa fa-plus"></i> Add New Category
                    </Button>
                  </Link>
                </div>
              </Stack>
            </CardHeader>
            <CardBody>
              

            <Row className="my-2 mb-2 float-end">
              <Col xs={"auto"} className="my-1 ">
                <FormGroup htmlFor="search" className="">
                  Search:
                </FormGroup>
              </Col>
              <Col xs={"auto"}>
                <InputGroup>
                  <Input
                    id="search"
                    type="text"
                    autoComplete="off"
                    placeholder="Search Category..."
                    name="name"
                    onChange={searchHandler}
                  />
                  <FormGroup>
                    {/* <Search /> */}
                  </FormGroup>
                </InputGroup>
              </Col>
            </Row>

              <DataTable
                columns={columns}
                data={data}
                progressPending={loadingListData}
                pagination={true}
                paginationServer
                onSort={handleSort}
                sortServer
                paginationTotalRows={count}
                paginationPerPage={sortingParams.limit}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

CategoryList.propTypes = {
  getCategoryList: PropTypes.func.isRequired,
  resetComponentStore: PropTypes.func.isRequired,
  sortingParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  categoryList: state.categorys.categoryList,
  loadingListData: state.categorys.loadingListData,
  sortingParams: state.categorys.sortingParams,
});

export default connect(mapStateToProps, {
  getCategoryList,
  resetComponentStore,
  deleteCategory,
})(CategoryList);
